/** Namespace `settings` — wird befüllt während der Komponenten-Migration. */
export const settings = {
  de: {
    settings: {
      title: 'Settings',
      subtitle: 'System-Einstellungen für SeaDent Dental Practice Management.',
      loading: 'Lade Einstellungen…',
      saving: 'Speichere…',
      sending: 'Sende…',
      selectAreaLabel: 'Einstellungs-Bereich wählen',
      tabsAria: 'Settings-Tabs',
      tabEmail: '✉️ Email',
      tabEmailTemplates: '📝 E-Mail-Texte',
      tabUsers: '👥 Benutzer',
      tabGcal: '📅 Google Calendar',
      tabBranding: '🎨 Branding',
      tabBilling: '🧾 Rechnungsstellung',
      tabSelfservice: '🔁 Self-Service',
      tabProviders: '🩺 Behandler',
      tabProcedures: '😁 Behandlungen',
      tabNoteTemplates: '📋 Doku-Vorlagen',
      tabOperatories: '🏢 Behandlungsräume',
      // Email-Versand (SMTP)
      smtpTitle: 'Email-Versand (SMTP)',
      smtpDescription: 'Konfiguration für ausgehende Mails (Terminbestätigungen, Stornierungen). All-Inkl-Mail-Konto unter <code>info@seadent.es</code>.',
      host: 'Host',
      port: 'Port',
      portHint: '587 = STARTTLS (Hetzner-tauglich), 465 = SSL (von Hetzner geblockt).',
      user: 'Benutzer',
      password: 'Passwort',
      passwordStored: '(gespeichert)',
      passwordPlaceholderStored: '•••••• (leer lassen → unverändert)',
      passwordPlaceholderEnter: 'Passwort eingeben',
      secureHint: 'SSL direkt nutzen (<code>secure=true</code>) — nur sinnvoll bei Port 465. Bei 587 bitte ausgelassen lassen (STARTTLS).',
      // Test-Email
      testEmailTitle: 'Test-Email senden',
      testEmailDescription: 'Prüft die SMTP-Verbindung mit den aktuell <strong>gespeicherten</strong> Werten und sendet eine kleine Test-Mail.',
      testRecipientPlaceholder: 'empfaenger@example.com',
      sendTest: 'Test senden',
      // Toasts / Fehler
      errorLoadEmail: 'Konnte Email-Einstellungen nicht laden — Defaults vorausgefüllt.',
      emailSaved: 'Email-Einstellungen gespeichert.',
      errorSave: 'Speichern fehlgeschlagen.',
      errorTestRecipient: 'Bitte eine Empfänger-Adresse für den Test angeben.',
      testAccepted: 'Test-Email akzeptiert ({{id}}).',
      errorTest: 'Test fehlgeschlagen.',
      errorTestDetail: 'Test fehlgeschlagen: {{detail}}',
      // Self-Service (Patienten sagen ab / verschieben per Link)
      selfservice: {
        title: 'Patienten-Self-Service',
        description: 'Patienten können ihren Termin über den „Termin verwalten"-Link in Bestätigungs- und Erinnerungs-Mails selbst absagen oder verschieben. Hier werden Fristen und Limits festgelegt.',
        enabled: 'Self-Service aktiv (Links in den Mails funktionieren)',
        cancelMinHours: 'Absage-Frist (Stunden)',
        cancelMinHoursHint: 'Online-Absagen sind bis so viele Stunden vor dem Termin möglich.',
        rescheduleMinHours: 'Umbuchungs-Frist (Stunden)',
        rescheduleMinHoursHint: 'Online-Verschieben ist bis so viele Stunden vor dem Termin möglich.',
        maxReschedules: 'Max. Verschiebungen',
        maxReschedulesHint: 'So oft darf ein Patient denselben Termin verschieben.',
        linkHint: 'Innerhalb der Frist sehen Patienten stattdessen die Telefonnummer der Praxis. Bei Deaktivierung zeigt die Seite nur noch die Termindetails an.',
        saved: 'Self-Service-Einstellungen gespeichert.',
        errorLoad: 'Konnte Self-Service-Einstellungen nicht laden — Defaults vorausgefüllt.',
      },
    },
  },
  es: {
    settings: {
      title: 'Ajustes',
      subtitle: 'Ajustes del sistema para SeaDent Dental Practice Management.',
      loading: 'Cargando ajustes…',
      saving: 'Guardando…',
      sending: 'Enviando…',
      selectAreaLabel: 'Seleccionar el área de ajustes',
      tabsAria: 'Pestañas de ajustes',
      tabEmail: '✉️ Email',
      tabEmailTemplates: '📝 Textos de correo',
      tabUsers: '👥 Usuarios',
      tabGcal: '📅 Google Calendar',
      tabBranding: '🎨 Marca',
      tabBilling: '🧾 Facturación',
      tabSelfservice: '🔁 Autoservicio',
      tabProviders: '🩺 Doctores',
      tabProcedures: '😁 Tratamientos',
      tabNoteTemplates: '📋 Plantillas de documentación',
      tabOperatories: '🏢 Salas de tratamiento',
      // Envío de correo (SMTP)
      smtpTitle: 'Envío de correo (SMTP)',
      smtpDescription: 'Configuración para correos salientes (confirmaciones de cita, cancelaciones). Cuenta de correo de All-Inkl en <code>info@seadent.es</code>.',
      host: 'Host',
      port: 'Puerto',
      portHint: '587 = STARTTLS (compatible con Hetzner), 465 = SSL (bloqueado por Hetzner).',
      user: 'Usuario',
      password: 'Contraseña',
      passwordStored: '(guardada)',
      passwordPlaceholderStored: '•••••• (dejar vacío → sin cambios)',
      passwordPlaceholderEnter: 'Introduzca la contraseña',
      secureHint: 'Usar SSL directamente (<code>secure=true</code>): solo tiene sentido con el puerto 465. Con el 587, déjelo desactivado (STARTTLS).',
      // Correo de prueba
      testEmailTitle: 'Enviar correo de prueba',
      testEmailDescription: 'Comprueba la conexión SMTP con los valores <strong>guardados</strong> actuales y envía un pequeño correo de prueba.',
      testRecipientPlaceholder: 'destinatario@example.com',
      sendTest: 'Enviar prueba',
      // Toasts / Errores
      errorLoadEmail: 'No se pudieron cargar los ajustes de correo; se han rellenado los valores predeterminados.',
      emailSaved: 'Ajustes de correo guardados.',
      errorSave: 'Error al guardar.',
      errorTestRecipient: 'Indique una dirección de destinatario para la prueba.',
      testAccepted: 'Correo de prueba aceptado ({{id}}).',
      errorTest: 'Error en la prueba.',
      errorTestDetail: 'Error en la prueba: {{detail}}',
      // Autoservicio (los pacientes cancelan / cambian la cita por enlace)
      selfservice: {
        title: 'Autoservicio para pacientes',
        description: 'Los pacientes pueden cancelar o cambiar su cita ellos mismos mediante el enlace «Gestionar cita» de los correos de confirmación y recordatorio. Aquí se definen los plazos y límites.',
        enabled: 'Autoservicio activo (los enlaces de los correos funcionan)',
        cancelMinHours: 'Plazo de cancelación (horas)',
        cancelMinHoursHint: 'Las cancelaciones en línea son posibles hasta tantas horas antes de la cita.',
        rescheduleMinHours: 'Plazo de cambio (horas)',
        rescheduleMinHoursHint: 'El cambio de fecha en línea es posible hasta tantas horas antes de la cita.',
        maxReschedules: 'Cambios máximos',
        maxReschedulesHint: 'Cuántas veces puede un paciente cambiar la misma cita.',
        linkHint: 'Dentro del plazo, los pacientes ven en su lugar el teléfono de la clínica. Si se desactiva, la página solo muestra los detalles de la cita.',
        saved: 'Ajustes de autoservicio guardados.',
        errorLoad: 'No se pudieron cargar los ajustes de autoservicio; se han rellenado los valores predeterminados.',
      },
    },
  },
};
